<template>
  <h2 class="mt-12 text-center font-headline text-h2 text-slate-darker">Snabba fakta om djuren</h2>
  <p class="py-2 text-center">Lär dig mer om djuren nedan. Svep för att se fler!</p>
  <div class="min-h-slider relative flex items-center md:mt-6">
    <client-only>
      <Carousel
        v-if="animals.length > 0"
        :items="animals"
        loop
        centered
        class="[--gap:16px] [--spv:1.2] min-[600px]:[--gap:50px] min-[600px]:[--spv:1.9] min-[800px]:[--spv:2.5] min-[1200px]:[--gap:30px] min-[1200px]:[--spv:4]"
      >
        <template #default="{ item }">
          <content-card class="h-full" :animal="item" :link="item._path"></content-card>
        </template>
        <template #controls="{ prev, next }">
          <carousel-arrows @prev="prev()" @next="next()" />
        </template>
      </Carousel>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import Carousel from 'refresh-ui/src/components/molecules/Carousel.vue'
import type { ContentfulAnimal } from '@/types/contentful'

defineProps<{ animals: ContentfulAnimal[] }>()
</script>

<style lang="postcss" scoped>
.min-h-slider {
  min-height: min(400px, 80vw);
  @screen md {
    min-height: 300px;
  }
}
</style>
